import { render, staticRenderFns } from "./SipSession.vue?vue&type=template&id=509a0f70&"
import script from "./SipSession.vue?vue&type=script&lang=js&"
export * from "./SipSession.vue?vue&type=script&lang=js&"
import style0 from "./SipSession.vue?vue&type=style&index=0&id=509a0f70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports